import { useRepositorySuspenseQuery } from '@mews-commander/data-access';

export const useCurrentEnterpriseAttachments = () => {
    const {
        data: { attachments: attachmentsData },
    } = useRepositorySuspenseQuery('reservationContractAttachments', 'getAll', {});

    return attachmentsData || [];
};
